import classNames from 'classnames';
import { ReactNode } from 'react';

const mapTypeToColor = {
  success: 'bg-[rgba(45,_183,_45_ 0.12)]',
  info: 'bg-[rgba(3,_105,_161,_0.12)]',
  warning: 'bg-[rgba(224,_114,_17,_0.12)]',
  critical: 'bg-[rgba(220,_38,_38,_0.12)]',
  neutral: 'bg-[#E5E5E5]',
};

interface BadgeProps {
  type: keyof typeof mapTypeToColor;
  children: ReactNode;
  prefix?: ReactNode;
  className?: string;
  onClick?: () => void;
}

const Badge = ({ children, type, prefix, className, onClick }: BadgeProps) => {
  return (
    <span
      title={typeof children === 'string' ? children : undefined}
      className={classNames(
        'flex flex-row gap-1 px-1.5 text-xs h-5 text-[rgba(23,_23,_23,_0.72)]',
        mapTypeToColor[type],
        className,
      )}
      style={{
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: 4,
      }}
      onClick={onClick}
    >
      {prefix}
      {children}
    </span>
  );
};

export default Badge;
